import React from 'react'

import './styles.global.scss';
import ValidatedTextInput from '../ValidatedTextInput';
import { FormControl, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';

const InputWithSelect = (props) => {
  const {
    value,
    onChange,
    style = {},
    name = 'InputWithSelect',
    InputProps = {},
    selectWidth = 150,
    selectValue,
    onSelect,
    options,
    className,
    selectDisabled,
    inputTestId,
    selectTestId,
    selectProps = {},
    ...other
  } = props;

  const getInputProps = () => {
    const testIdProps = inputTestId ? { 'data-testid': inputTestId } : {};
    return {
      ...InputProps,
      ...(InputProps.inputProps ? { inputProps: { ...InputProps.inputProps, ...testIdProps } } : {}),
      endAdornment: renderEndAdornment()
    };
  };

  const renderEndAdornment = () => {
    return (
      <FormControl style={{ width: `${selectWidth * 2}px` }} variant="outlined" className={`innerSelectWrapper`}>
        <Select
          value={selectValue}
          className={`innerSelect`}
          onChange={onSelect}
          variant="outlined"
          data-test={'select'}
          data-testid={selectTestId}
          disabled={!!selectDisabled}
          {...selectProps}
        >
          {options.map((option, idx) => {
            return (
              <MenuItem
                value={option.value}
                key={option.value}
                data-test={'menu-item'}
                data-testid={`${selectTestId}-${idx}`}
                disabled={!!selectDisabled}
              >
                <div className={`InputWithSelectWrapper-custom-innerOption`} data-test={'option'}>{option.label ?? option.value}</div>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  return (
    <div className={`InputWithSelectWrapper-custom`}>
      <ValidatedTextInput
        value={value}
        onChange={onChange}
        fullWidth
        style={style}
        variant="outlined"
        name={name}
        className={className}
        InputProps={getInputProps()}
        inputProps={{...(inputTestId ? { 'data-testid': inputTestId } : {})}}
        {...other}
      />
    </div>
  );
};

InputWithSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  selectWidth: PropTypes.number,
  selectValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  inputTestId: PropTypes.string,
  selectTestId: PropTypes.string,
  selectProps: PropTypes.object,
};

export default InputWithSelect
